import {Component, OnDestroy, OnInit} from '@angular/core';
import {permissions} from '../../../../permissions';
import {MOesWorkspaceService} from '../../services/m-oes-workspace.service';

@Component({
    selector: 'app-m-dashboard',
    templateUrl: './m-dashboard.component.html',
    styleUrls: ['./m-dashboard.component.scss'],
    providers: [],
    preserveWhitespaces: true
})
export class MDashboardComponent implements OnInit, OnDestroy {

    public permissions = permissions;
    public allowInventoryManagement: boolean;

    private mobileWorkspaceService: MOesWorkspaceService;

    constructor() {
    }

    ngOnInit() {
        window.scroll(0, 0);
        this.mobileWorkspaceService = MOesWorkspaceService.getInstance();
        this.workspaceServiceListener(0);
    }

    ngOnDestroy() {
    }

    private workspaceServiceListener(attempt: number) {
        this.allowInventoryManagement = this.mobileWorkspaceService.allowInventoryManagement;
        setTimeout(() => {
            if (attempt < 10) {
                this.workspaceServiceListener(attempt + 1);
            }
        }, 400);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/views/dashboard/m-dashboard.component.ts